module.exports = __webpack_public_path__ + "img/avatar4.862f4519.png";